import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { SelectRecordEmitter, EditDataEmitter } from '../edit-card/edit-card.component';
import { EditService, EditCardColumn } from 'app/services/edit.service';
import { AttrIndexService } from 'app/services/attr-index.service';
import { DomainService } from 'app/services/domain.service';

// export interface EditDataEmitter {
// 	recId;
// 	changedCol?: string;
// 	isInitEdit?: boolean;
// }
@Component({
  selector: 'app-edit-card-fishbone',
  templateUrl: './edit-card-fishbone.component.html',
  styleUrls: ['./edit-card-fishbone.component.css', '../edit-card/edit-card.component.css']
})
export class EditCardFishboneComponent implements OnInit {

	@Input() columns: EditCardColumn[];
	@Input() getRecordId: (rec) => string;

	@Input() selectedRecord;
	@Input() editRecordList: any[];

	originList: any[] = [];

	@Input() disableEditing: boolean;

	isEditedCol: string;
	shouldDeleteCol: string;

	commitDisableReason = ''; // TODO
	fsCode;// TODO

	@Output() edit: EventEmitter<any> = new EventEmitter(); // TODO: type
	@Output() clickDiscard: EventEmitter<any> = new EventEmitter();
	@Output() clickCommit: EventEmitter<any> = new EventEmitter();
	@Output() clickAdd: EventEmitter<any> = new EventEmitter();
	@Output() selectRecord: EventEmitter<SelectRecordEmitter> = new EventEmitter();

	constructor(
		private attrIndexService: AttrIndexService,
		private editService: EditService,
		private domainService: DomainService
		// private editCardService: EditCardService
	) { }

	onChange(col?: EditCardColumn, isOnlyGeomChange?: boolean, isDeleteChange?: boolean) {
		if (!this.selectedRecord) {
			return;
		}
		const data: EditDataEmitter = {
			recId: this.getRecordId(this.selectedRecord),
			card: this.selectedRecord,
			changedCol: col ? col.prop : null
			// deleteStatusChange: deleteStatusChange
		}
		if (isDeleteChange) {
			data.changedCol = this.shouldDeleteCol;
		}
		if (!this.selectedRecord[this.isEditedCol]) {
			this.selectedRecord[this.isEditedCol] = true;

			// data.isInitEdit = true;
		}
		if (col && !isOnlyGeomChange) {
			// TODO

			// this.domainService.updateDependentDomains(this.selectedRecord, this.columns, col);
		}
		this.edit.emit(data);
	}
	onChangeDelete(isDelete: boolean) {
		this.selectedRecord[this.shouldDeleteCol] = isDelete;
		this.onChange(null, null, true);
	}

	clearEdits() {
		this.editRecordList = [];
		this.originList = [];
		this.changeSelectedRecord(null);
	}

	changeSelectedRecord(rec, skipTrigger?: boolean) {
		if (rec) {
			this.selectedRecord = rec;
		} else {
			this.selectedRecord = null;
		}
		let id;
		if (this.selectedRecord) {
			id = this.getRecordId(this.selectedRecord);
		}
		// TODO
		// this.editCardService.updateDependentDomains(this.selectedRecord, this.columns);
		
		if (!skipTrigger) {
			this.selectRecord.emit({
				id: id
			});
		}
	}

	checkCommitDisabled() {
		return !this.editRecordList.length;
	}
	goPrevRecord() {
		const idx = this.editRecordList.indexOf(this.selectedRecord);
		if (idx <= 0) {
			return;
		}
		this.changeSelectedRecord(this.editRecordList[idx - 1]);
	}
	goNextRecord() {
		const idx = this.editRecordList.indexOf(this.selectedRecord);
		if (idx >= this.editRecordList.length - 1) {
			return;
		}
		this.changeSelectedRecord(this.editRecordList[idx + 1]);
	}
	commit() {
		this.clickCommit.emit(this.originList);
	}
	discard() {
		this.clickDiscard.emit(this.originList);
	}
	ngOnInit() {
		this.isEditedCol = this.attrIndexService.isEditedKey;
		this.shouldDeleteCol = this.attrIndexService.isDeletedKey;
	}
	ngOnChanges(changes: SimpleChanges) {
		if (changes.selectedRecord && !changes.selectedRecord.firstChange) {
			this.changeSelectedRecord(changes.selectedRecord.currentValue, true);
		}
		// For fishbone, the editList contains all data that might be edited instead of data already edited
		if (changes.editRecordList && !changes.editRecordList.firstChange) {
			if (this.editRecordList) {
				this.originList = JSON.parse(JSON.stringify(this.editRecordList));
			}
		}
	}

}
